// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsAnticipations_LinkRecebimentoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payments/anticipations/link_recebimento
 * and DELETE /payments/anticipations/unlink_recebimento
 *
 * Links or unlinks an anticipation to a recebimento.
 * Shared contract for both endpoints since fields are identical.
 */
import { registerContract } from './validate'

export interface SubaccountsAnticipations_LinkRecebimentoInput {
recebimento_id: number
anticipation_id: number
}

registerContract('SubaccountsAnticipations_LinkRecebimentoInput', {
  recebimento_id:  { type: 'number',  required: true },
  anticipation_id: { type: 'number',  required: true },
})
